import { render, staticRenderFns } from "./JobPostJobDetail.vue?vue&type=template&id=2461bf22&scoped=true&"
import script from "../../../services/company/job_post/job-post-job-detail.js?vue&type=script&lang=js&"
export * from "../../../services/company/job_post/job-post-job-detail.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/job_details.css?vue&type=style&index=0&id=2461bf22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461bf22",
  null
  
)

export default component.exports